import Vue from 'vue';

export default (method = 'post', params = {}) => (
  new Promise((resolve, reject) => {
    let request = null;
    if (method === 'post') request = Vue.$http.post('account/set-overview-per-page', params);
    else request = Vue.$http.get(`account/get-overview-per-page/${params.from}`);
    request.then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error);
    });
  })
);




// WEBPACK FOOTER //
// ./src/app/services/account/rememberPerPage.js